export default [
  {
    path: '/livsmiljoer',
    name: 'Livsmiljoer',
    component: () =>
      import(/* webpackChunkName: "Livsmiljoer" */ '../views/Livsmiljoer.vue'),
    meta: {
      scrollTop: true
    }
  },
  {
    path: '/livsmiljoer/grunda-klipp-och-stenbottnar',
    name: 'grunda-klipp-och-stenbottnar',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "LivsmiljoerChild" */ '../views/PageChildMiljo.vue'
      ),
    meta: {
      scrollTop: true,
      miljoName: 'Grunda klipp- och stenbottnar',
      pageId: 3496,
      envId: 2
    }
  },
  {
    path: '/livsmiljoer/djupa-klipp-och-stenbottnar',
    name: 'djupa-klipp-och-stenbottnar',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "LivsmiljoerChild" */ '../views/PageChildMiljo.vue'
      ),
    meta: {
      scrollTop: true,
      miljoName: 'Djupa klipp- och stenbottnar',
      pageId: 3500,
      envId: 5
    }
  },
  {
    path: '/livsmiljoer/grunda-mjuka-bottnar',
    name: 'grunda-mjuka-bottnar',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "LivsmiljoerChild" */ '../views/PageChildMiljo.vue'
      ),
    meta: {
      scrollTop: true,
      miljoName: 'Grunda mjuka bottnar',
      pageId: 3499,
      envId: 1
    }
  },
  {
    path: '/livsmiljoer/djupa-mjuka-bottnar',
    name: 'djupa-mjuka-bottnar',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "LivsmiljoerChild" */ '../views/PageChildMiljo.vue'
      ),
    meta: {
      scrollTop: true,
      miljoName: 'Djupa mjuka bottnar',
      pageId: 3498,
      envId: 4
    }
  },
  {
    path: '/livsmiljoer/det-fria-vattnet',
    name: 'det-fria-vattnet',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "LivsmiljoerChild" */ '../views/PageChildMiljo.vue'
      ),
    meta: {
      scrollTop: true,
      miljoName: 'Det fria vattnet',
      pageId: 3497,
      envId: 3
    }
  }
]
